import React, { PureComponent } from 'react';

import Icon from  './icon';

const WIDTH = 1;
const HEIGHT = 10/13;

const Element = ({ className, getSize, color, style }) => (
    <svg className={className} style={style} width={getSize(WIDTH)} height={getSize(HEIGHT)} viewBox="0 0 13 10" version="1.1" xmlns="http://www.w3.org/2000/svg">
        <path d="M1.083 7.583A1.084 1.084 0 0 1 0 6.501V1.082C0 .485.487 0 1.083 0H9.75c.598 0 1.083.486 1.083 1.082v3.306a2.71 2.71 0 1 1-1.896 5A2.71 2.71 0 0 1 4.93 7.584H1.083zm4.333-2.166a1.625 1.625 0 1 1 1.501-1.001 2.714 2.714 0 0 1 2.02.28 2.69 2.69 0 0 1 .813-.308V1.083H1.083V6.5H4.93c.081-.4.25-.768.487-1.083zm4.876 3.25a1.625 1.625 0 1 0-.488-3.176c.307.44.488.974.488 1.55 0 .577-.18 1.112-.488 1.551.154.049.318.075.488.075zM1.625 5.148c0-.15.122-.273.268-.273h1.089a.27.27 0 0 1 .268.273v.537a.272.272 0 0 1-.268.273H1.893a.27.27 0 0 1-.268-.273v-.537zm5.958-3.25c0-.15.122-.273.269-.273H8.94a.27.27 0 0 1 .268.273v.537a.272.272 0 0 1-.268.273H7.852a.27.27 0 0 1-.269-.273v-.537zm0 6.769a1.625 1.625 0 1 0 0-3.25 1.625 1.625 0 0 0 0 3.25z" fill={color} fillRule="evenodd"/>
    </svg>
)

export default class IconMoney extends PureComponent {
    render() {
        return <Icon color={this.props.color} size={this.props.size} style={this.props.style} baseline={this.props.baseline} className={this.props.className}><Element /></Icon>;
    }
}
